import gql from 'graphql-tag';
import Client from "../services/Client";
import Cookie from "../services/Cookie";

const ReportAction = {
    /**
     * List of student Recent Result exam wise report for student
     * @author: Susanta Chakraborty
     * @params: inputObj: <Object> {userId: <Integer>, courseId: <Integer>, countryCode: <String>}
     */
    reportList(inputObj) {
        const REPORT_LIST = gql`
          query fetchUserReportList($token: AccessToken!, $input: ReportListInput!) {
              fetchUserReportList(token: $token, input: $input) {
                  code
                  status
                  message
                  data {
                      reports {
                          examId
                          userExamId
                          totalTime
                          remainingTime
                          questionAttempt
                          questionLeft
                          startTime
                          endTime
                          totalCorrect
                          timeTaken
                          score
                          userExamStatus
                          createdAt
                          createdBy
                          updatedBy
                          updatedAt
                          examTitle
                          courseId
                          paid
                          worksheetId
                          worksheetName
                          timeStatus
                          pageId
                          pageName
                          sectionId
                          sectionName
                          topicName
                          attemptedCount
                      }
                      totalCount
                  }
              }
          }
        `;
        return Client.query({
            query: REPORT_LIST,
            variables: {
                input: {
                    filters: {
                        userId: inputObj.userId,
                        courseId: inputObj.courseId,
                        examType: inputObj.examType,
                    },
                    pagination: {
                        status: inputObj.status,
                        limit: inputObj.limit,
                        offset: inputObj.offset,
                    },
                    searchfield: inputObj.searchfield
                },
                token: {
                  accessToken : Cookie.getCookie('_token'),
                  accessRole : 6
                }
            },
        });
    },

    /**
     * User Exam attempted list
     * @author: Susanta Chakraborty
     * @params: inputObj = {filters: {userId: <Integer>, examId: <Integer>, examType: <String>, courseId: <Integer>}
     * pagination: {status: <Bool>, limit: <Integer>, offset: <Integer>}}
     */
    sameExamAttemptedList(inputObj) {
        const ATTEMPTED_LIST = gql`
    query fetchSameExamAttemptedList($token: AccessToken!,$input: SameExamAttemptedListInput!){
      fetchSameExamAttemptedList(token: $token, input: $input){
        code
        status
        message
        data{
          totalCount
          reports{
            examId
            userExamId
            totalTime
            remainingTime
            questionAttempt
            questionLeft
            startTime
            endTime
            totalCorrect
            timeTaken
            score
            userExamStatus
            createdAt
            createdBy
            updatedBy
            updatedAt
            examTitle
            courseId
            paid
            worksheetId
            worksheetName
            timeStatus
            pageId
            pageName
            sectionId
            sectionName
          }
        }
      }
    }
    `;
        return Client.query({
            query: ATTEMPTED_LIST,
            variables: {
                token: {
                    accessToken : Cookie.getCookie('_token'),
                    accessRole : 6
                },
                input: {
                    filters: {
                        userId: inputObj.userId,
                        examId: inputObj.examId,
                        courseId: inputObj.courseId,
                        examType: inputObj.examType
                    },
                    pagination: {
                        status: inputObj.status,
                        limit: inputObj.limit,
                        offset: inputObj.offset
                    }
                }
            }
        });
    },

    /**
     * User report card | Only Full Mock
     * @author: Susanta Chakraborty
     * @params: userExamId: <Integer>
     */
    fullMockReportCard(userExamId) {
        const FETCH_FULLMOCK_REPORT_CARD = gql`
          query fetchFullMockReportCard($token: AccessToken!, $input: FullMockReportCardInput!) {
            fetchFullMockReportCard(token: $token, input: $input) {
              code
              status
              message
              data {
                totalCount
                sections {
                  sectionId
                  sectionName
                  sectionType
                  sectionWeight
                  sectionTotalScore
                  userMockSectionId
                  mockSectionTimeId
                  userMockId
                  breakTime
                  breakEnd
                  sectionTotalTime
                  sectionTotalCorrect
                  remainingTime
                  questionAttempt
                  questionLeft
                  extraTime
                  examId
                  totalCorrect
                  totalScore
                  sectionScore
                  sequence
                }
              }
            }
          }`;
        return Client.query({
            query: FETCH_FULLMOCK_REPORT_CARD,
            variables: {
                input: {
                    userExamId: userExamId,
                },
                token: {
                    accessToken : Cookie.getCookie('_token'),
                    accessRole : 6
                }
            }
        });
    },

     /**
     * Fetch Student exam statistics
     * @author: Arijit Deb Roy
     * @params: inputObj: <Object> {userExamId: <Integer>, examType: <String>}
     */
    reportStats(inputObj) {
        const REPORT_STATISTICS = gql`
         query fetchUserReportStats($token: AccessToken!, $input: ReportStatisticsInput!){
          fetchUserReportStats(token: $token , input: $input){
            code
            status
            message
            data{
              reports {
                courseId
                examId
                userExamId
                examTitle
                examSubType
                examEndDate
                totalExamQuestion
                remainingTime
                questionAttempt
                questionLeft
                score
                percentile
                startTime
                endTime
                createdAt
                totalCorrect
                timeTaken
                totalTime
                worksheetId
                worksheetName
                topicId
                topicName
                sectionId
                sectionName
                pageId
                pageName
                difficultyName
              }
            }
          }
        }
        `;
        return Client.query({
            query: REPORT_STATISTICS,
            variables: {
                input: {
                    filters: {
                        userExamId: inputObj.userExamId,
                        examType: inputObj.examType,
                    },
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                }
            }
        });
    },
    /**
     * Fetch Student exam statistics
     * @author: Susanta Chakraborty
     * @params: inputObj: <Object> {userExamId: <Integer>, examType: <String>}
     */
    unAuthReportStats(inputObj) {
        const REPORT_STAT_UNAUTH = gql`
         query unAuthReportStats($input: ReportStatisticsInput!){
            unAuthReportStats(input: $input){
                code
                status
                message
                data{
                reports {
                    courseId
                    examId
                    userExamId
                    examTitle
                    examEndDate
                    totalExamQuestion
                    remainingTime
                    questionAttempt
                    questionLeft
                    score
                    percentile
                    startTime
                    endTime
                    createdAt
                    totalCorrect
                    timeTaken
                    totalTime
                    worksheetId
                    worksheetName
                    topicId
                    topicName
                    sectionId
                    sectionName
                    pageId
                    pageName
                    difficultyName
                }
            }
        }
        }
        `;
        return Client.query({
            query: REPORT_STAT_UNAUTH,
            variables: {
                input: {
                    filters: {
                        userExamId: inputObj.userExamId,
                        examType: inputObj.examType,
                    },
                },
            }
        });
    },
};
export default ReportAction;
